import { LayoutWithCarousel } from '@/components/Layout';
import { TextBodySmall, TextHeadlineLarge } from '@/components/text/Texts';
import routes from '@/constants/routes';
import OTPForm from '@/modules/authentication/components/OTPForm';
import { Card } from 'primereact/card';
import { useLocation, useNavigate } from 'react-router-dom';

const OTPScreen = () => {
	const location = useLocation();
	const navigate = useNavigate()
	const processId = location.state?.processId;

	// Redirect to login if no ProcessId is provided
	if (!processId) {
		navigate(routes['/login']);
	}
	return (
		<LayoutWithCarousel>
			<Card className="login-screen">
				<TextHeadlineLarge
					className="mb-1 text-neutral30"
					text="We’ve sent an OTP to your email"
				/>
				<TextBodySmall
					className="mb-8 text-formTextGray"
					text="Please enter the OTP below to verify your account. If you didn’t receive the email, check your spam folder or request a new OTP"
				/>
				<OTPForm />
			</Card>
		</LayoutWithCarousel>
	);
};

export default OTPScreen;
